module.exports = __webpack_public_path__ + "static/media/framLogin2.e6c62fe6.png";